// @flow

export const PERMISSIONS_LOADING = 'permissions/LOADING';
export const PERMISSIONS_SUCCESS = 'permissions/SUCCESS';
export const PERMISSIONS_ERROR = 'permissions/ERROR';

type State = {
  loading: boolean,
  data: { [string]: boolean },
  error: ?string
};

export const initialState: State = {
  loading: false,
  data: {},
  error: null
};

function reducer(state: State = initialState, action: any): State {
  const { type, payload } = action;

  switch (type) {
    case PERMISSIONS_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };

    case PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          ...payload
        },
        error: null
      };

    case PERMISSIONS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/permissions.js